import { render, staticRenderFns } from "./e-retailers.vue?vue&type=template&id=e47292b6"
import script from "./e-retailers.vue?vue&type=script&lang=js"
export * from "./e-retailers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports